import { googleMapsApiKey } from '../Config/env';

let loaderPromise;
let lastGoogleMapsError = null;
let authFailureHandlerInstalled = false;

export const GOOGLE_MAPS_AUTH_FAILURE_EVENT = 'lpb:google-maps-auth-failure';

const configurationError = () => new Error(
  'Google Maps a refusé le chargement. Vérifiez la facturation, les API activées et les domaines autorisés pour la clé.',
);

const emitAuthFailure = () => {
  lastGoogleMapsError = configurationError();
  loaderPromise = undefined;
  window.dispatchEvent(new CustomEvent(GOOGLE_MAPS_AUTH_FAILURE_EVENT, {
    detail: { message: lastGoogleMapsError.message },
  }));
};

const installAuthFailureHandler = () => {
  if (authFailureHandlerInstalled || typeof window === 'undefined') return;
  authFailureHandlerInstalled = true;

  const previousHandler = window.gm_authFailure;
  window.gm_authFailure = () => {
    emitAuthFailure();
    if (typeof previousHandler === 'function') previousHandler();
  };
};

const installBootstrapLoader = () => {
  if (window.google?.maps?.importLibrary) return;

  ((g) => {
    let h;
    let a;
    let k;
    const p = 'The Google Maps JavaScript API';
    const c = 'google';
    const l = 'importLibrary';
    const q = '__ib__';
    const m = document;
    const b = window;
    const google = b[c] || (b[c] = {});
    const maps = google.maps || (google.maps = {});
    const libraries = new Set();
    const params = new URLSearchParams();
    const load = () => h || (h = new Promise((resolve, reject) => {
      a = m.createElement('script');
      params.set('libraries', [...libraries].join(','));
      Object.keys(g).forEach((key) => {
        params.set(key.replace(/[A-Z]/g, (letter) => `_${letter[0].toLowerCase()}`), g[key]);
      });
      params.set('callback', `${c}.maps.${q}`);
      a.src = `https://maps.${c}apis.com/maps/api/js?${params.toString()}`;
      maps[q] = resolve;
      a.onerror = () => {
        lastGoogleMapsError = new Error('Le service Google Maps est momentanément inaccessible.');
        reject(lastGoogleMapsError);
      };
      a.nonce = m.querySelector('script[nonce]')?.nonce || '';
      m.head.append(a);
    }));

    if (maps[l]) {
      console.warn(`${p} only loads once. Ignoring:`, g);
      return;
    }

    maps[l] = (library, ...args) => {
      libraries.add(library);
      return load().then(() => maps[l](library, ...args));
    };
  })({
    key: googleMapsApiKey,
    v: 'weekly',
    language: 'fr',
    region: 'FR',
    authReferrerPolicy: 'origin',
  });
};

export const isGoogleMapsConfigured = Boolean(googleMapsApiKey);

export const getGoogleMapsLastError = () => lastGoogleMapsError;

export const resetGoogleMapsLoader = () => {
  loaderPromise = undefined;
  lastGoogleMapsError = null;
};

export const loadGoogleMaps = async (...libraries) => {
  if (!googleMapsApiKey) {
    throw new Error('La clé Google Maps n’est pas configurée pour cette version de Le Petit Boulot.');
  }

  installAuthFailureHandler();

  if (!loaderPromise) {
    loaderPromise = Promise.resolve().then(() => {
      installBootstrapLoader();
      return window.google.maps;
    });
  }

  const maps = await loaderPromise;
  await Promise.all(libraries.filter(Boolean).map((library) => maps.importLibrary(library)));
  if (lastGoogleMapsError) throw lastGoogleMapsError;
  return window.google.maps;
};
